import { createRoot } from 'react-dom/client'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import App from './App.tsx'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 2 * 60 * 1000, // 2 minutes - optimiert für Skeleton-Vermeidung
      gcTime: 30 * 60 * 1000, // 30 minutes - längere Cache-Retention
      refetchOnWindowFocus: false,
      refetchOnMount: 'always', // Refetch nur wenn stale
      retry: 1,
    },
  },
});

// Make queryClient globally accessible for prefetch in Index.tsx
;(window as any).__queryClient = queryClient;

// Service Worker für Offline-Unterstützung und Performance
// NUR in Produktion aktiv, in Entwicklung deaktiviert

if ('serviceWorker' in navigator) {
  if (import.meta.env.PROD) {
    // Produktion: Service Worker registrieren
    window.addEventListener('load', async () => {
      try {
        const registration = await navigator.serviceWorker.register('/sw.js', {
          scope: '/',
        });
        
        // Prüfe auf Updates
        registration.addEventListener('updatefound', () => {
          const newWorker = registration.installing;
          newWorker?.addEventListener('statechange', () => {
            if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
              // New version available - could notify user
            }
          });
        });
        
        // Prüfe periodisch auf Updates (alle 60 Minuten)
        setInterval(() => {
          registration.update();
        }, 60 * 60 * 1000);
        
      } catch (error) {
        console.error('[SW] Registration failed:', error);
      }
    });
  } else {
    // Entwicklung: Service Worker deregistrieren
    navigator.serviceWorker.getRegistrations().then((regs) => {
      regs.forEach((reg) => {
        reg.unregister();
        console.log('[SW] Unregistered for development');
      });
    });
  }
}

createRoot(document.getElementById("root")!).render(
  <QueryClientProvider client={queryClient}>
    <App />
  </QueryClientProvider>
);
